// extracted by mini-css-extract-plugin
export var dropdownContainer = "_ms-0";
export var leftAlign = "_ms-4";
export var listItem = "_ms-2";
export var listItemWrapper = "_ms-1";
export var operationText = "_ms-3";